import { Divider as MuiDivider, styled } from "@mui/material";

export const Divider = styled(MuiDivider)(({ theme }) => ({
	background: "#7C7B7B",
}));
